export default __webpack_public_path__ + "static/media/half-logo.b33a3a17.png";